import React, { useEffect, useState } from "react";
import { formatDate } from "src/shared/Format/dateFormat";

import {
  apiCallResponse,
  apiDownloadDocument,
  apiExportToExcel,
} from "src/_apiConfig/apiCall";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import {
  FilterContainsInsensitive,
  FilterEqual,
} from "../common/FilterCondition";
import TableButtonClick from "../common/Table/TableButtonClick";
import CommonList from "../common/CommonList";
import Auth from "src/auth";
import {
  CommonSearchExtra,
  SCInput,
  SCSelect,
  updateSearchStatus,
} from "../common/CommonSearch";

const PaymentRefundReport = () => {
  const { authenticated } = Auth();
  const [usersData, setUserData] = useState(); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage
  const [isExporting, setIsExporting] = useState(false); //Export To Excel Loader Manage
  const [textField, settextField] = useState("lotNo");

  // const [rejectionReason, setRejectionReason] = useState();
  // const [selectedLotPaymentId, setSelectedLotPaymentId] = useState();
  // const [rejectionWindowOpen, setRejectionWindowOpen] = useState(false);

  // // Your default search model
  const SearchFilterModel = {
    lotNoSearch: "",
    RefundType: "",
    RefundStatus: "Pending",
  };
  const [search, setSearch] = useState(SearchFilterModel); // Search Manage

  useEffect(() => {
    setloading(true);
    resetPageLimit();
    getPageCount();
    console.log(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    orderClick ? setorder("asc") : setorder("desc");
    getRefundList();
    console.log(2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textField, orderClick]);

  useEffect(() => {
    if (isSearch === false) {
      getRefundList();
      console.log(3);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, itemPerPage]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getRefundList();
      setIsClear(false);
      setIsSearch(false);
      console.log(4);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);
  function reset() {
    setpageLimit(0);
  }

  //Pagging Disabled /Enable manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  //Pagging manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";

    filter = "&$filter=";

    filter = FilterContainsInsensitive(filter, "lotNo", search.lotNoSearch);
    filter = FilterEqual(filter, "refundtype", search.RefundType);
    filter = FilterEqual(filter, "tran_status", search.RefundStatus);

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };
  const getPageCount = async () => {
    debugger;
    if (authenticated) {
      await apiCallResponse(`Report/GetRefundList?${filterManage()}`).then(
        (res) => {
          debugger;
          if (res.success) paggingManage(parseInt(res.data.length) || 0);
        }
      );
    }
  };
  const getRefundList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      const header = new Headers();
      await apiCallResponse(
        `Report/GetRefundList?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`,
        "GET",
        header,
        null
      )
        .then((res) => {
          if (res.success) {
            debugger;
            setUserData(res.data);
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          }
        })
        .finally(() => {
          setloading(false);
        });
    }
  };
  const ExportToExcel = async () => {
    const ReportListExcelUrl = `Report/RefundReportExportToExcel?${filterManage()}`;
    const ReportListExcelFileName = "PaymentRefundStatus.xls";
    setIsExporting(true);
    try {
      await apiExportToExcel(
        pageCount,
        ReportListExcelUrl,
        null,
        ReportListExcelFileName,
         "GET"
      ).finally(() => {
        setIsExporting(false);
      });
    } catch (error) {
      // Handle any errors that might occur during the export process
      console.error("Error exporting to Excel:", error);
      alert("records not available");
      setIsExporting(false); // Reset isExporting state if an error occurs
    }
  };

  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    // if (textField !== getTextField) {
    //   setorder("asc");
    // } else {
    //   !orderClick ? setorder("asc") : setorder("desc");
    // }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  const fields = [
    {
      key: "lotNo",
      _style: { width: "5%" },
      label: TableHeaderSet("Lot No", "lotNo"),
    },
    {
      key: "srno",
      label: TableHeaderSet("Sr No", "srno"),
    },
    {
      key: "beneficiary_name",
      label: TableHeaderSet("Beneficiary Name", "beneficiary_name"),
    },
    {
      key: "beneficiary_bank_name",
      label: <div>Bank Name</div>,
      sorter: false,
      filter: false,
    },
    {
      key: "beneficiary_account_number",
      label: <div>Account No</div>,
      sorter: false,
      filter: false,
    },

    {
      key: "amount",
      label: TableHeaderSet("Amount", "amount"),
    },
    {
      key: "transferer_name",
      label: <div>Transferer Name</div>,

      sorter: false,
      filter: false,
    },
    {
      key: "transferee_name",
      label: <div>Transferee Name</div>,

      sorter: false,
      filter: false,
    },
    {
      key: "tran_status",
      label: <div>Status</div>,

      sorter: false,
      filter: false,
    },
    // {
    //   key: "refund_type_display",
    //   label: <div>Refund Type</div>,

    //   sorter: false,
    //   filter: false,
    // },
    {
      key: "refundTypeName",
      label: <div>Refund Type</div>,

      sorter: false,
      filter: false,
    },

    {
      key: "createddate_display",
      label: <div>Refund Date</div>,

      sorter: false,
      filter: false,
    },
    {
      key: "download_Refund_lot_receipt",
      label: "Download Receipt",
      sorter: false,
      filter: false,
    },
  ];

  const DownloadRefundReceipt = async (SrNo, RefundId) => {
    const header = new Headers();
    await apiDownloadDocument(
      SrNo + ".pdf",
      `LotDetails/DownloadRefundReceipt?SrNo=${SrNo}&RefundId=${RefundId}`,
      "GET",
      header,
      null
    ).then((res) => {
      if (res.success) alert(res.message);
      else alert(res.message);
    });
  };
  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    console.log("updateSearch :", search, name, value);
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
    paggingManage(pageCount);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUserData([]);
  };

  const refundTypeList = [
    { value: "1", label: "Lot Transfer EMD" },
    { value: "2", label: "EMD" },
    { value: "3", label: "Security Deposite" },
    { value: "4", label: "5% Security Deposite" },
    { value: "5", label: "Lot Transfer SD" },
    { value: "6", label: "25% Security Deposite" },
    { value: "7", label: "Installment Adjustment With EMD" },
  ];

  const refundStatusList = [
    { value: "Pending", label: "Pending" }, //defaultValue
    { value: "Paid", label: "Paid" },
    { value: "Cancelled", label: "Cancelled" },
  ];

  let searchControl = (
    <>
      <SCInput
        label={"Lot No. "}
        name={"lotNoSearch"}
        value={search.lotNoSearch}
        onChange={updateSearch}
      />
      <SCSelect
        labelname="Refund Type"
        name="RefundType"
        value={search.RefundType}
        onChange={updateSearch}
        items={refundTypeList}
        isSelectShow={true}
        //defaultValue={search.RefundType}
      />
      <SCSelect
        labelname="Refund Status"
        name="RefundStatus"
        value={search.RefundStatus}
        onChange={updateSearch}
        items={refundStatusList}
        isSelectShow={true}
        //defaultValue={search.RefundStatus}
      />
      {/*<CRow>
        <CCol xl={3}>
          <CLabel>Lot No:</CLabel>{" "}
          <CInput
            onChange={(e) => {
              setLotNoSearch(e.target.value);
            }}
          />
        </CCol> 

        <CCol xl={3}>
          <CLabel>Refund Type:</CLabel>{" "}
          <CSelect
            custom
            name="select"
            id="select"
            onChange={(e) => {
              setRefundType(e.target.value);
            }}
          >
            <option value="" defaultValue>
              Select Refund Type
            </option>
            <option value="1">Lot Transfer EMD</option>
            <option value="2">EMD</option>
            <option value="3">Security Deposite</option>
            <option value="4">5 % Security Deposite</option>
            <option value="5">Lot Transfer SD</option>
            <option value="6">25% Security Deposite</option>
            <option value="7">Installment Adjustment With EMD</option>
          </CSelect>
        </CCol> 
        <CCol xl={3}>
          <CLabel>Status:</CLabel>{" "}
          <CSelect
            custom
            name="select"
            id="select"
            onChange={(e) => {
              setRefundStatus(e.target.value);
            }}
          >
            <option value="">Select All</option>
            <option value="Pending">Pending</option>
            <option value="Paid">Paid</option>
            <option value="Cancelled">Cancelled</option>
          </CSelect>
        </CCol>
      </CRow>*/}
    </>
  );
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isExportToExcelDisplay={true}
      isExporting={isExporting}
      isDisabledExport={usersData && usersData.length > 0 ? false : true}
      ExportToExcel={ExportToExcel}
    />
  );
  return (
    <>
      {/* <CCard>
        <CCardHeader className="mb-3 ">
          <CRow xl={12} className="mt-3">
            <CCol xl={10}>
              <h3>Payment Refund Status Report</h3>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <div>
            <CRow>
              <CCol xl={3}>
                <CButton
                  className="mt-4  "
                  color="success"
                  onClick={() => {
                    reset();
                    getRefundList();
                  }}
                >
                  Search
                </CButton>

                <CButton
                  className="mt-4 ml-2"
                  color="success"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  Clear
                </CButton>
                <CButton
                  className="mt-4 ml-2"
                  color="success"
                  disabled={
                    usersData != null && usersData.length > 0 ? false : true
                  }
                  onClick={() => {
                    ExportToExcel();
                  }}
                >
                  Export To Excel
                </CButton>
              </CCol>
            </CRow>
            <CRow className="mt-3">
              <CCol className="float-right col-md-auto mt-3 mb-3 ">
                <CLabel>Item Per Page</CLabel>
                <CSelect
                  aria-label="Default select example"
                  onChange={(e) => {
                    reset();
                    setItemPerPage(e.target.value);
                  }}
                >
                  <Options />
                </CSelect>
              </CCol>
            </CRow>
          </div>
          <div className=""> */}
      <CommonList
        items={usersData}
        fields={fields}
        listName="Payment Refund Status Report"
        loading={loading}
        prev={prevButton}
        next={nextButton}
        disabledprev={disabledprev}
        disablednext={disablednext}
        additional={additional}
        id="LotPaymentId"
        scopedSlots={{
          createddate_display: (item, index) => {
            return (
              <td className="py-2">
                <span>{formatDate(item.createddate)}</span>
              </td>
            );
          },
          refund_type_display: (item, index) => {
            return (
              <td className="py-2">
                <span>
                  {item.refundtype === "1"
                    ? "Lot Transfer EMD"
                    : item.tenderPaymentComplete === "2"
                    ? "EMD"
                    : item.tenderPaymentComplete === "3"
                    ? "Security Deposite"
                    : item.tenderPaymentComplete === "4"
                    ? "5% Security Deposite"
                    : item.tenderPaymentComplete === "5"
                    ? "Lot Transfer SD"
                    : ""}
                </span>
              </td>
            );
          },
          download_Refund_lot_receipt: (item, index) => {
            return (
              <>
                <TableButtonClick
                  buttonName={" Download Refund Receipt"}
                  isDisplayAllow={
                    true
                    //item.refundReceiptFilePath !== "" && item.srno !== undefined
                  }
                  onClick={() => DownloadRefundReceipt(item.srno, item.id)}
                />
              </>
            );
          },
        }}
      />
      {/* </div>

          <div className="float-right mt-3 mb-3">
            {/* <CRow > * /}
            <CButton
              color="success"
              onClick={() => {
                setpageLimit(pageLimit - Number(itemPerPage));
              }}
              disabled={disabledprev}
              style={{ visibility: disabledprev ? "hidden" : "visible" }}
            >
              Prev
            </CButton>
            <CButton
              className="ml-2 mr-3"
              color="success"
              onClick={() => {
                setpageLimit(pageLimit + Number(itemPerPage));
              }}
              disabled={disablednext}
              style={{ visibility: disablednext ? "hidden" : "visible" }}
            >
              Next
            </CButton>
          </div>
        </CCardBody>
      </CCard>*/}
    </>
  );
};

export default PaymentRefundReport;
